import { render, staticRenderFns } from "./text-editors.vue?vue&type=template&id=355a5e7d"
import script from "./text-editors.vue?vue&type=script&lang=js"
export * from "./text-editors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports